import React from 'react';
import propTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import Button from 'tailwind-components/Button/Button';

/**
 * shortcut shown above the carrier notes when the request section is scrolled out of view
 * @param text - button label, tells the agent what the section below does
 * @param onClick - scrolls the sidebar down to the request section
 */
export default function ScrollToRequestButton({ text, onClick }) {
  return (
    <div className='mt-2.5 pt-2.5 border-t border-grey-lightest first:mt-0 first:border-t-0 first:pt-0'>
      <Button
        variant='primaryLight'
        size='small'
        text={text}
        icon={<ChevronDown />}
        iconPosition='right'
        fill
        onClick={onClick}
      />
    </div>
  );
}

ScrollToRequestButton.propTypes = {
  text: propTypes.string.isRequired,
  onClick: propTypes.func.isRequired
};
